import React from 'react';
import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';
import IconButton from '@/components/Packaging/common/IconButton';

interface Props {
  color: string;
  className?: string;
  onClick(): void;
}

const UnlockButton: React.FC<Props> = ({ color, className, onClick }) => (
  <IconButtonStyled title="Unlock" color={color} className={className} onClick={onClick}>
    <PolarisIcon icon="lock_closed" height={16} width={16} />
  </IconButtonStyled>
);

export default UnlockButton;

const IconButtonStyled = styled(IconButton)<{ color: string }>`
  position: absolute;
  top: ${({ theme }) => theme.spacing(0.75)};
  right: ${({ theme }) => theme.spacing(1)};
  cursor: pointer;
  color: ${({ color }) => color};

  &:hover {
    opacity: 0.7;
  }
`;
